import React from "react";
import BrandComponents from "../../Masters/Brand/BrandComponents";

function PoEnquiryTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "Status", field: "status" },
    { label: "Type", field: "purchaseenquirytype" },
    { label: "Category", field: "purchaseenquirycategory" },
    { label: "Job Number", field: "jobnumber" },
    { label: "Enquiry No.", field: "enquiryno" },
    { label: "Enquiry Date", field: "enquirydate" },
    { label: "Supplier Name", field: "companyname" },
    { label: "Contact Person", field: "contactperson" },

  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"PURCHASE ENQUIRY"}
        apiField={"purchaseEnquiry"}
        addButton={"+ ADD"}
        createRoute={"/poenquiryindex/create"}
        updateRoute={"/poenquiryView"}
        viewRoute={"/poenquiryView"}
      />
    </div>
  );
}

export default PoEnquiryTable;
